var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComparison = function SvgComparison(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.8337 8.33333h-8.33337c-.45834 0-.83334.375-.83334.83334 0 .45833.375.83333.83334.83333h8.33337c.4583 0 .8333-.375.8333-.83333 0-.45834-.375-.83334-.8333-.83334zm0-3.33333h-8.33337c-.45834 0-.83334.375-.83334.83333 0 .45834.375.83334.83334.83334h8.33337c.4583 0 .8333-.375.8333-.83334 0-.45833-.375-.83333-.8333-.83333zm4.1666 6.6667v-2.50003c0-.45834-.375-.83334-.8333-.83334s-.8333.375-.8333.83334v2.50003h-2.5c-.4584 0-.8334.375-.8334.8333s.375.8333.8334.8333h2.5v2.5c0 .4584.375.8334.8333.8334s.8333-.375.8333-.8334v-2.5h2.5c.4584 0 .8334-.375.8334-.8333s-.375-.8333-.8334-.8333zm-12.49997 1.6666h5c.45833 0 .83333-.375.83333-.8333s-.375-.8333-.83333-.8333h-5c-.45834 0-.83334.375-.83334.8333s.375.8333.83334.8333z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComparison, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comparison.1507a93b.svg";
export { ForwardRef as ReactComponent };